export default __webpack_public_path__ + "static/media/2249.5848a179.svg";